<app-split-container>
  <div slot="left">
    <app-login-dialog-image
      *ngIf="!customMessage()"
      [title]="'login.signupCode.infoTitle' | translate"
      [subtitle]="'login.signupCode.infoSubtitle' | translate"
    >
      <app-signup-code-image></app-signup-code-image>
    </app-login-dialog-image>

    <div *ngIf="customMessage()" class="custom-message" [innerHTML]="customMessage() | safe"></div>
  </div>

  <div slot="right">
    <form id="signup-code-form" [formGroup]="form" (submit)="validateCode($event)">
      <opac-text-input formControlName="code">{{ 'signup.custom.code' | translate }}</opac-text-input>
      <opac-button actionType="submit" [disabled]="form.invalid" form="signup-code-form">{{ 'signup.custom.validate' | translate }}</opac-button>
    </form>

    <opac-divider>{{ 'common.or' | translate }}</opac-divider>

    <div class="links-container">
      <span>
        {{ 'login.signup.goToLoginText' | translate }}
        <a
          href="#"
          (click)="loadLogin($event)"
          (keydown.enter)="loadLogin($event)"
          (keydown.space)="loadLogin($event)"
        >
          {{ 'login.signup.goToLoginLink' | translate }}
        </a>
      </span>
    </div>
  </div>
</app-split-container>
